<template>
  <div class="common-box">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form
          @search="handleSearch"
          @refresh="handleRefresh"
        >
          <div slot="content">
            <el-form-item label="资源名称：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.resourceName"
                placeholder="请输入资源名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="资源类型：">
             <el-select size="mini" clearable @change="handleSearchListData" v-model="form.resourceType"
              placeholder="请选择资源类型">
             	<el-option v-for="item in resourceTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
             </el-select>
            </el-form-item>
            <el-form-item label="资源编号：">
              <el-input
                @change="handleSearchListData"
                size="mini"
                v-model.trim="form.resourceCode"
                placeholder="请输入资源编号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" @click="handleAdd">添加</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="handleDelete"
          plain
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportResource"
          plain
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          show-summary
          sum-text="合计"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="resourceName" label="资源名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="resourceType" label="资源类型" width="200">
      			<template slot-scope="scope">
      				<span>{{scope.row.resourceType.name}}</span>
      			</template>
      		</el-table-column>
          <el-table-column show-overflow-tooltip prop="resourceCode" label="资源编号" width="200"></el-table-column>
      		<el-table-column show-overflow-tooltip prop="dorder" label="排序号" width="200"></el-table-column>
      		<el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="160px" fixed="right">
            <template slot-scope="scope">
      				<el-button size="mini" type="text" @click="handleSetResources(scope.row)">资源值</el-button>
      				<div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="handleCheck(scope.row)">查看</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-dialog v-if="showAdd" @cancel="showAdd = false"></add-dialog>
  </div>
</template>

<script>
  import addDialog from './components/addDialog.vue'
  export default {
    name: 'DOM2',
    components: {
      addDialog
    },
    data() {
      return {
        showAdd: false,
        resourceTypeList: [
          { code: 1, name: 1}
        ],
        form: {
          resourceCode: '',
          resourceType: '',
          resourceName: ''
        },
        tableLoading: false,
        list: [
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
          { resourceName:1, resourceType: { name: 1 }, resourceCode: 1, order: 1 },
        ],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0
      }
    },
    methods: {
      handleSearch() {

      },
      handleRefresh() {

      },
      handleSearchListData() {

      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleSetResources(row) {

      },
      handleCheck(row) {

      },
      handleEdit(row) {

      },
      handleDelete() {

      },
      handleAdd() {
        this.showAdd = true
      },
      exportResource() {

      },
      handleSizeChange(val) {
        this.pageSize = val
      },
      handleCurrentChange(val) {
        this.pageIndex = val
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dom2/dom2.vue